import {
  SelectOptionsMessage as SelectOptionsMessageType,
  Conversation,
} from '@stripe-internal/conversations-client';
import {view} from '@sail/ui';
import {ChatRow} from '../../../Chat';
import {SelectOptionsMessage} from './SelectOptionsMessage';

type Props = {
  conversation: Conversation;
  message: SelectOptionsMessageType;
  disableInteraction?: boolean;
};

export const SelectOptionsMessageRow = ({
  conversation,
  message,
  disableInteraction,
}: Props) => {
  return (
    <view.div data-testid="select-options-message-row">
      <ChatRow>
        <SelectOptionsMessage
          conversation={conversation}
          message={message}
          disableInteraction={disableInteraction}
        />
      </ChatRow>
    </view.div>
  );
};
